<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('chat-bots') }} -> <router-link to="/list-group-manager">{{ $t('list-groups') }}</router-link> -> {{ groupName }}
    </h1>
    <div class="main__body">
      <h2 class="title">
        {{ $t('list-manager') }}
      </h2>
      <div class="input-search">
        <input class="search large" v-model="data.search" v-on:keyup.enter="getManagers()"/>
        <img src="@/assets/icon/search.svg">
      </div>
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">№</th>
          <th scope="col">{{ $t('active') }}</th>
          <th scope="col">{{ $t('FIO') }}</th>
          <th scope="col">Telegram_nickname</th>
          <th scope="col">{{ $t('phone') }}</th>
          <th scope="col">Email</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody v-if="managers.length > 0">
        <tr v-for="(item, index) in managers" v-bind:key="item.id" v-if="item.id">
          <th scope="row" class="small-first-th">
            {{ index + 1}}
          </th>
          <th scope="row">
            <label class="table__selected">
              <input type="checkbox" :checked="parseInt(item.active)" @click="setActive(item.id)">
              <span class="checkmark"></span>
            </label>
          </th>
          <td class="pointer" v-on:click.self="showClientModal(item.id)">{{ (item.middlename ? item.middlename : '') + ' ' + (item.firstname ? item.firstname : '') + ' ' + (item.lastname ? item.lastname : '') }}</td>
          <td>{{ item.username }}</td>
          <td>{{ item.phone }}</td>
          <td>{{ item.email }}</td>
          <td class="active">
            {{ $t('in-group') }}
            <label class="table__td-trash pointer" @click="deleteAccept(item.id, item.firstname, item.middlename, item.lastname)">
              <img src="@/assets/icon/trash.svg">
            </label>
          </td>
        </tr>
        </tbody>
        <div class="tbody-empty" v-else>
          <p>Ничего не найдено</p>
        </div>
      </table>
    </div>
    <div class="form-row mb-2">
      <a class="btn btn-primary" @click="showModalAddManagerInGroup">Добавить менеджера в группу</a>
    </div>
    <remove-manager-from-group :manager="this.deleteClient" :group_name="this.groupName" :group_id="this.data.group_id"
                               v-show="isModalDeleteManagerFromGroup"
                               @close="closeModalDeleteManagerFromGroup"></remove-manager-from-group>
    <add-manager-in-group-modal :group="this.$route.params.id"
        v-show="isModalAddManagerInGroup" @close="closeModalAddManagerInGroup"></add-manager-in-group-modal>
    <clientModal :id="selectUser" v-show="isModalClientVisible"
                 @close="closeClientModal"/>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import axios from "axios";
import loading from "vue-loading-overlay";
import RemoveManagerFromGroup from "../components/modal/group/remove-manager-from-group";
import AddManagerInGroupModal from "../components/modal/group/add-manager-in-group-modal";
import clientModal from "../components/modal/clientModal";
export default {
  name: 'historyTriggerMessage',
  data: function () {
    return {
      groupName: '',
      managers: [],
      selectUser: 0,
      isModalClientVisible: false,
      data: {
        group_id: this.$route.params.id,
        search: '',
      },
      deleteClient: {
        id: 0,
        firstname: '',
        middlename: '',
        lastname: '',
      },
      isModalAddManagerInGroup: false,
      isModalDeleteManagerFromGroup: false,
      isLoading: false,
      fullPage: true,
    }
  },
  created: function () {
    this.getManagers();
  },
  mounted() {
    this.$root.$on('getManagersFromGroup', () => {
      this.getManagers();
    });
  },
  methods: {
    getManagers: function () {
      this.isLoading = true;
      axios.post('getListManagerFromGroup', this.data).then(response => {
        var status = response.data.status;
        if(status){
          this.managers = response.data.managers;
          if(!this.groupName){
            this.groupName = this.managers[0].name;
          }
          this.isLoading = false;
        }
      });
    },
    setActive: function(id){
      this.isLoading = true;
      var data = {
        group_id: this.$route.params.id,
        manager_id: id
      }
      axios.post('setActiveManager', data).then(response => {
        var status = response.data.status;
        if(status){
          var active = response.data.active;
          this.getManagers();
          this.isLoading = false;
          if(active == 0){
            this.$toast.success("Активность менеджера снята");
          }else{
            this.$toast.success("Активность менеджера установлена");
          }
        }
      });
    },
    deleteAccept: function(id, firstname, middlename, lastname){
      this.deleteClient.id = id;
      this.deleteClient.firstname = firstname;
      this.deleteClient.middlename = middlename;
      this.deleteClient.lastname = lastname;
      this.showModalDeleteManagerFromGroup();
    },
    showModalDeleteManagerFromGroup() {
      this.isModalDeleteManagerFromGroup = true;
    },
    closeModalDeleteManagerFromGroup() {
      this.isModalDeleteManagerFromGroup = false;
    },
    showModalAddManagerInGroup() {
      this.isModalAddManagerInGroup = true;
    },
    closeModalAddManagerInGroup() {
      this.isModalAddManagerInGroup = false;
    },
    showClientModal(id) {
      this.selectUser = id;
      this.isModalClientVisible = true;
    },
    closeClientModal() {
      this.isModalClientVisible = false;
    },
  },
  components: {
    AddManagerInGroupModal, RemoveManagerFromGroup, loading, clientModal
  }
}
</script>